import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon } from 'semantic-ui-react'
import './ExperienceCard.css'

/**
 * Compact card displaying a single Work Experience, Education, or Certification entry.
 * Shows primary info (title + date) on the first row and secondary details on the second row.
 *
 * Props:
 *   title          {string}    Main text displayed in bold (e.g. Business Title, Degree, Certification name)
 *   dateRange      {string}    Formatted date string shown on the right (e.g. "Jul 2022 – Present")
 *   subtitle       {string}    [optional] Secondary line of text (e.g. "Customer · Project Title")
 *   badge          {string}    [optional] Small label shown next to the title (e.g. sector)
 *   visibleOnCv    {boolean}   [optional] If provided, shows a visibility badge
 *   editable       {boolean}   Whether to show the Edit button
 *   onEdit         {Function}  Callback invoked when Edit button is clicked
 */
const ExperienceCard = ({ title, dateRange, subtitle, badge, visibleOnCv, editable, onEdit }) => {
  return (
    <div className="exp-card">
      <div className="exp-card-row exp-card-row-primary">
        <span className="exp-card-title">{title || '—'}</span>
        {badge && <span className="exp-card-badge">{badge}</span>}
        {visibleOnCv !== undefined && (
          <span className={visibleOnCv ? 'exp-card-badge' : 'exp-card-badge exp-card-badge-hidden'}>
            {visibleOnCv ? 'Visible' : 'Hidden'}
          </span>
        )}
        <span className="exp-card-date">{dateRange || ''}</span>
      </div>
      <div className="exp-card-row">
        <span className="exp-card-secondary">{subtitle || ''}</span>
        {editable && (
          <span className="exp-card-actions">
            <Button icon size="mini" basic color="grey" onClick={onEdit} title="Edit">
              <Icon name="pencil" />
            </Button>
          </span>
        )}
      </div>
    </div>
  )
}

ExperienceCard.propTypes = {
  title: PropTypes.string,
  dateRange: PropTypes.string,
  subtitle: PropTypes.string,
  badge: PropTypes.string,
  visibleOnCv: PropTypes.bool,
  editable: PropTypes.bool.isRequired,
  onEdit: PropTypes.func,
}

export default ExperienceCard
